<template>
  <CompareLocationsListPage
    :can-show-select-favorite-list-dialog="canShowSelectFavoriteListDialog"
    :card-component="cardComponent"
    :default-compare-field="defaultCompareField"
    handle-fetch-locations="fetchForecastSnowSummary"
    :is-favorites="isFavorites"
    locations-field="forecastSnowSummaries"
    range-field="forecastSnowSummaryRange"
    :selected-nav-item="1"
    :sort-options="sortOptions"
  />
</template>

<script>
import ExplorePageMixin from '@@/components/Compare/Mixins/ExplorePageMixin';
import SummaryPageMixin from '@@/components/Compare/Mixins/SummaryPageMixin';

export default {
  name: 'ExploreSummaryPage',

  mixins: [
    ExplorePageMixin,
    SummaryPageMixin,
  ],

  data() {
    return {
      isFavorites: false,
    };
  },
};
</script>
